import {FC, ReactElement} from 'react';

import {Box} from '@mui/material';

import {StyledBasketAppHeader} from './styles';

export type BasketAppHeaderProps = {
  leadingElement?: ReactElement;
  headerTitle?: ReactElement;
  trailingElement?: ReactElement;
};

const BasketAppHeader: FC<BasketAppHeaderProps> = ({leadingElement, headerTitle, trailingElement}) => {
  return (
    <StyledBasketAppHeader>
      <Box minWidth={'35px'} display="flex" justifyContent="flex-start">
        {leadingElement}
      </Box>
      <Box display="flex" alignItems="center" justifyContent="center" gap="5px">
        {headerTitle}
      </Box>
      <Box minWidth={'35px'} display="flex" justifyContent="flex-end">
        {trailingElement}
      </Box>
    </StyledBasketAppHeader>
  );
};

export default BasketAppHeader;
